const pad = n => String(n).padStart(2, '0');
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})/;

/**
 * Convierte Date o string ('YYYY-MM-DD' o ISO con hora) a 'YYYY-MM-DD'.
 * Los strings se leen tal cual (sin pasar por Date) para evitar desfases de zona horaria.
 * Los Date se leen en hora local. Devuelve '' si no hay valor válido.
 */
export const toApiDate = value => {
  if (!value) return '';
  if (typeof value === 'string') {
    const m = ISO_DATE.exec(value);
    return m ? `${m[1]}-${m[2]}-${m[3]}` : '';
  }
  if (value instanceof Date && !isNaN(value.getTime())) {
    return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;
  }
  return '';
};

/** 'YYYY-MM-DD' -> 'DD/MM/YYYY'. Devuelve '' si no es una fecha válida. */
export const formatFechaDisplay = value => {
  const m = ISO_DATE.exec(typeof value === 'string' ? value : '');
  return m ? `${m[3]}/${m[2]}/${m[1]}` : '';
};

/** Date -> 'YYYY-MM-DD HH:mm:ss' (hora local), formato del campo `creado` de asistentes/media. */
export const toApiDateTime = date => `${toApiDate(date)} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;

/** 'YYYY-MM-DD' -> 'DD / MM / YYYY' (vista de detalle). Devuelve '' si no es una fecha válida. */
export const formatFechaDetalle = value => {
  const m = ISO_DATE.exec(typeof value === 'string' ? value : '');
  return m ? `${m[3]} / ${m[2]} / ${m[1]}` : '';
};
